import type { FC, PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';
import { SiteProvider } from '@anywayseo/tools';
import { CtaProvider } from 'components/cta-provider';
import { legalRoutes } from 'content/data';

import useSite from './use-site';
import usePageI18n from './use-page-i18n';
import { FooterExtra } from './footer-extra';
import { HeaderToolbar } from './header-toolbar';
import { Logo } from './logo';
import { getLocaleFromPath } from './utils';

type PageWrapperProps = PropsWithChildren<{ location: Location }>;

const PageWrapper: FC<PageWrapperProps> = ({ children, location }) => {
  const { metadata } = useSite();
  const locale = getLocaleFromPath(location.pathname);
  const pageI18n = usePageI18n(locale);

  return (
    <I18nextProvider i18n={pageI18n}>
      <CtaProvider locale={locale}>
        <SiteProvider
          metadata={{ ...metadata, lang: locale }}
          configs={{
            header: {
              toolbar: <HeaderToolbar locale={locale} />,
            },
            footer: {
              navigation: legalRoutes[locale],
              extra: <FooterExtra />,
              showDisclaimer: false,
            },
          }}
          assets={{ images: { logo: <Logo /> } }}
        >
          {children}
        </SiteProvider>
      </CtaProvider>
    </I18nextProvider>
  );
};

export default PageWrapper;
